import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-39e33f52")
const _hoisted_1 = { class: "dashboard" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatisticalPanel = _resolveComponent("StatisticalPanel")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_PieChart = _resolveComponent("PieChart")!
  const _component_BaseCard = _resolveComponent("BaseCard")!
  const _component_MapChart = _resolveComponent("MapChart")!
  const _component_RoseChart = _resolveComponent("RoseChart")!
  const _component_LineChart = _resolveComponent("LineChart")!
  const _component_BarChart = _resolveComponent("BarChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { gutter: 10 }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topPanelData, (item) => {
          return (_openBlock(), _createBlock(_component_el_col, {
            key: item.title,
            md: 12,
            lg: 6,
            xl: 6
          }, {
            default: _withCtx(() => [
              _createVNode(_component_StatisticalPanel, { panelData: item }, null, 8, ["panelData"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, {
      gutter: 10,
      class: "row"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 7 }, {
          default: _withCtx(() => [
            _createVNode(_component_BaseCard, { title: "分類商品數量(餅圖)" }, {
              default: _withCtx(() => [
                _createVNode(_component_PieChart, { "pie-data": _ctx.categoryGoodsCount }, null, 8, ["pie-data"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 10 }, {
          default: _withCtx(() => [
            _createVNode(_component_BaseCard, { title: "不同城市商品销量" }, {
              default: _withCtx(() => [
                _createVNode(_component_MapChart, { "map-data": _ctx.addressGoodsSale }, null, 8, ["map-data"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 7 }, {
          default: _withCtx(() => [
            _createVNode(_component_BaseCard, { title: "分類商品數量(玫瑰圖)" }, {
              default: _withCtx(() => [
                _createVNode(_component_RoseChart, { "rose-data": _ctx.categoryGoodsCount }, null, 8, ["rose-data"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { gutter: 10 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_BaseCard, { title: "分類商品的銷量" }, {
              default: _withCtx(() => [
                _createVNode(_component_LineChart, _normalizeProps(_guardReactiveProps(_ctx.categoryGoodsSale)), null, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(_component_BaseCard, { title: "分類商品的收藏" }, {
              default: _withCtx(() => [
                _createVNode(_component_BarChart, _normalizeProps(_guardReactiveProps(_ctx.categoryGoodsFavor)), null, 16)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}